import React, {useEffect, useState} from "react";
import {Avatar, Button, Modal} from "antd";
import "./new-campaign-modal.css";
import CampaignTriggerSelector from "../../campaignTriggerSelector/CampaignTriggerSelector";
import {FieldTimeOutlined, MessageOutlined, SlidersOutlined, SmileOutlined, UserOutlined} from "@ant-design/icons";
import StepsProcess from "../../stepsProcess/StepsProcess";
import CampaignStep1 from "./CampaignStep1";
import CampaignSegmentSelector from "../../campaignSegmentSelector/CampaignSegmentSelector";
import useAppContext from "../../../hooks/useAppContext";
import Step4 from "../../messageCreationFlow/step4/Step4";
import {Campaign} from "../../../types/CampaignProps";

interface NewCampaignModalProps {
    isOpen: boolean;
    onClose: () => void;
    campaignIdToEdit?: number;
}

export interface FormValuesProps {
    title: string;
    active: boolean;
}

export const DEFAULT_FORM_VALUES = {
    title: '', active: true
}

const NewCampaignModal = ({
    isOpen,
    onClose,
    campaignIdToEdit,
}: NewCampaignModalProps) => {
    const [step, setStep] = useState(1);
    const { data: { campaigns }} = useAppContext();
    const [campaignId, setCampaignId] = useState<number | undefined>(undefined);
    const [templateId, setTemplateId] = useState<number | undefined>(undefined);
    const [campaign, setCampaign] = useState<Campaign | null>(null);

    useEffect(() => {
        setCampaignId(campaignIdToEdit);
        setTemplateId(undefined);
    }, [campaignIdToEdit, isOpen]);

    const onTemplateCreated = (campaignId: number, templateId: number) => {
        setTemplateId(templateId);
        setCampaignId(campaignId);
        setStep(2);
    }

    const onTriggerUpdate = () => {
        console.log("campaignIdToEdit: ", campaignIdToEdit);
        if(campaignIdToEdit) {
            onClose();
        }
    }

    const onCancel = () => {
        onClose();
    }

    useEffect(() => {
        if(campaignId) {
            setCampaign(campaigns.data.find((c: Campaign) => c.id === campaignId));
        }
    }, [campaigns, campaignId]);

    const steps = [
        {
            title: 'Template',
            icon: <MessageOutlined />,
        },
        {
            title: 'Audience',
            icon: <UserOutlined />
        },
        {
            title: 'Trigger',
            icon: <SlidersOutlined />,
        },
        {
            title: 'Done',
            icon: <SmileOutlined />,
        },
    ];

    return (
        <Modal
            open={isOpen}
            okButtonProps={{ style: { display: 'none' }}}
            cancelButtonProps={{ style: { display: 'none' }}}
            width={1024}
            destroyOnHidden={true}
            onCancel={onClose}
            className="new-campaign-modal-container"
            style={{ top: '40px' }}
            modalRender={(node) => (
                <div id="new-campaign-modal">{node}</div>
            )}
        >
            <StepsProcess steps={steps} onFirstSentenceBack={onClose} showProgressCircles={false}>
                <CampaignStep1 onCancel={onCancel} campaignId={campaignId} templateId={templateId} onCompleted={onTemplateCreated} />
                {campaignId ? <CampaignSegmentSelector campaignId={campaignId} /> : null}
                {campaignId ? <CampaignTriggerSelector campaignId={campaignId} onSubmitSettings={onTriggerUpdate} onCancel={onCancel} /> : null}
                <Step4 onClose={onClose} isCampaign={true} formValues={{ title: campaign?.title || '' }} />
            </StepsProcess>
        </Modal>
    );
}

export default NewCampaignModal;